// extracted by mini-css-extract-plugin
module.exports = {"tabs":"ViewTabs_tabs__2UBZf","tab":"ViewTabs_tab__3fwbH","tabActive":"ViewTabs_tabActive__1qkdO","icon":"ViewTabs_icon__3Io7D"};